/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_A3dInputs */

const en_mk_sol_lembaga_a3d = /** @type {(inputs: Mk_Sol_Lembaga_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totals spending per programme and prepares the accountability material.`)
};

const id_mk_sol_lembaga_a3d = /** @type {(inputs: Mk_Sol_Lembaga_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merekap pengeluaran per program dan menyiapkan bahan pertanggungjawaban.`)
};

/**
* | output |
* | --- |
* | "Totals spending per programme and prepares the accountability material." |
*
* @param {Mk_Sol_Lembaga_A3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_a3d = /** @type {((inputs?: Mk_Sol_Lembaga_A3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_A3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_a3d(inputs)
	return en_mk_sol_lembaga_a3d(inputs)
});